'use strict';
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const _CaretDownOutlined = _interopRequireDefault(require('./lib/icons/CaretDownOutlined'));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

const _default = _CaretDownOutlined;
exports.default = _default;
module.exports = _default;